<template>
    <div class="flex gap-2 items-center">
        <label class="w-32 text-sm">
            <slot name="label">
                {{ label }}
            </slot>
        </label>
        <div class="w-6 flex justify-center">
            <FieldInfoPopover v-if="showInfo" :field="field" :value="value" :sex="sex" class="print:hidden" />
        </div>
        <InputText :modelValue="value" @update:modelValue="$emit('update:value', $event)" :readonly="readonly"
            :disabled="disabled"
            :class="['w-20', inputClass, (readonly || disabled) ? 'bg-gray-100 text-gray-700 cursor-not-allowed' : ''].join(' ')"
            :pt="{ root: { 'data-cy': dataCy } }" />
        <InputText v-if="showSecond" :modelValue="secondValue" @update:modelValue="$emit('update:secondValue', $event)"
            :class="`w-20 ${secondClass} ${secondDisabled ? 'pointer-events-none' : ''}`" :readonly="secondDisabled"
            :disabled="secondDisabled" />
        <span v-if="unit" class="text-xs text-gray-500">{{ unit }}</span>
    </div>
</template>

<script setup>
import InputText from "primevue/inputtext";
import FieldInfoPopover from "./FieldInfoPopover.vue";

defineProps({
    label: {
        type: String,
        required: false
    },

    // for popover
    field: {
        type: String,
        required: true
    },
    sex: {
        type: String,
        default: "F"
    },
    showInfo: {
        type: Boolean,
        default: true
    },

    // input 1
    value: {
        type: [String, Number],
        default: ""
    },
    inputClass: {
        type: String,
        default: ""
    },
    readonly: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },

    // input 2
    showSecond: {
        type: Boolean,
        default: false
    },
    secondValue: {
        type: [String, Number],
        default: ""
    },
    secondClass: {
        type: String,
        default: ""
    },
    secondDisabled: {
        type: Boolean,
        default: true
    },

    // unit
    unit: {
        type: String,
        default: ""
    },
    dataCy: {
        type: String,
        default: ""
    }
});

defineEmits(["update:value", "update:secondValue"]);
</script>